module.exports = __webpack_public_path__ + "img/pronged-driftwood-4.710d4dda.jpg";